"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'attendances',
  path: '/attendances',
  meta: {
    expanded: false,
    title: 'Ponto digital',
    iconClass: 'icon-ic_operadores',
    requiresAuth: true
  },
  children: [{
    name: 'attendances-dashboard',
    path: '/attendances/dashboard',
    icon: 'icon-ic_operadores',
    meta: {
      title: 'Dashboard',
      requiresAuth: true
    }
  }, {
    name: 'attendances',
    path: '/attendances',
    icon: 'icon-ic_operadores',
    meta: {
      title: 'Entradas / Saídas',
      requiresAuth: true
    }
  }, {
    name: 'attendances-punchs',
    path: '/attendances/punchs',
    icon: 'icon-ic_calendar',
    meta: {
      title: 'Pontos',
      requiresAuth: true
    }
  }, {
    name: 'attendances-timesheets',
    path: '/attendances/timesheets',
    icon: 'icon-ic_calendar',
    meta: {
      title: 'Apuração e Cálculo',
      requiresAuth: true
    }
  }, {
    name: 'attendances-absences',
    path: '/attendances/absences',
    icon: 'icon-ic_calendar',
    meta: {
      title: 'Ausências',
      requiresAuth: true
    }
  }, {
    name: 'attendances-verified-photos',
    path: '/attendances/verified-photos',
    icon: 'icon-ic_operadores',
    meta: {
      title: 'Fotos reconhecidas',
      requiresAuth: true
    }
  }, {
    name: 'attendances-devices',
    path: '/attendances/devices',
    icon: 'icon-ic_operadores',
    meta: {
      title: 'Dispositivos reconhecidos',
      requiresAuth: true
    }
  }, {
    name: 'attendances-settings',
    path: '/attendances/settings',
    icon: 'icon-ic_settings',
    meta: {
      title: 'Configurações',
      requiresAuth: true
    }
  }]
};